import { Image, useMantineTheme } from "@mantine/core";
import { useShownColorScheme } from "hooks/useShownColorScheme";
import trackbookIcon from "assets/main/trackbook_icon_dark.png";

export const LoadingScreen = () => {
  const theme = useMantineTheme();
  // The shown color scheme ("auto" resolved to the system's), read right away so the screen doesn't flash
  const colorScheme = useShownColorScheme();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        width: "100%",
        backgroundColor: colorScheme === "dark" ? theme.colors.dark[4] : "#fff",
      }}
    >
      <Image src={trackbookIcon} style={{ width: "8%" }} />
    </div>
  );
};
